export default {
    'export': 'تصدير',
    'export-as-excel': 'تصدير إكسل',
    'print-trial-balance': 'طباعة الميزان',
    'search-about-account-number-or-name': 'بحث عن رقم أو اسم الحساب',
    'brief': '(مختصر)',
    'from-account': 'من حساب',
    'to-account': 'إلى حساب',
    'show-main-accounts': 'عرض الحسابات الرئيسية',
    'balanced-accounts-only': 'حسابات بأرصدة فقط',
    'show-all-columns': 'عرض المجاميع',
    refresh: 'تحديث',
    cancel: 'إلغاء',

    'account-statement': 'كشف حساب',

    'sum-result-headers': {
        'debit-sum': 'مجموع المدين',
        'credit-sum': 'مجموع الدائن',
        'debit-balance': 'رصيد مدين',
        'credit-balance': 'رصيد دائن',
    },

    'exchange-currencies-headers': {
        'difference': 'الفرق',
        'equivalent-currency': 'عملة مكافئة',
        'currency-equivalent-balance': 'الرصيد بعملة مختلفة',
    },

    headers: {
        'account-no': 'رقم الحساب',
        'account-name': 'اسم الحساب',
        'parent-account': 'الحساب الرئيسي',
        'debit-sum': 'مجموع المدين',
        'credit-sum': 'مجموع الدائن',
        'debit-balance': 'رصيد مدين',
        'credit-balance': 'رصيد دائن',
    },
}